// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.media-modal-content {
  --background: #000;
}

.media-slides {
  height: 100%;
}

ion-slide {
  height: 100%;
}

.swiper-zoom-container {
  width: 100%;
  height: 100%;
}
.swiper-zoom-container img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.media-video {
  width: 100%;
  max-height: 100%;
  background: #000;
}

.empty-msg {
  color: #fff;
  margin-top: 40px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/image-modal/image-modal.page.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAGA;EACE,WAAA;EACA,YAAA;AAAF;AAEE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AAAJ;;AAIA;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;AADF;;AAIA;EACE,WAAA;EACA,gBAAA;AADF","sourcesContent":[".media-modal-content {\n  --background: #000;\n}\n\n.media-slides {\n  height: 100%;\n}\n\nion-slide {\n  height: 100%;\n}\n\n// Images: contain (so the whole image is visible and zoomable), not cropped.\n.swiper-zoom-container {\n  width: 100%;\n  height: 100%;\n\n  img {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n  }\n}\n\n.media-video {\n  width: 100%;\n  max-height: 100%;\n  background: #000;\n}\n\n.empty-msg {\n  color: #fff;\n  margin-top: 40px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
